"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleResponse = void 0;
async function handleResponse(res) {
    if (res.status !== 200) {
        throw new Error(`${await res.text()}`);
    }
    const body = await res.text();
    try {
        return JSON.parse(body);
    }
    catch (e) {
        return body;
    }
}
exports.handleResponse = handleResponse;
